<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row">
  @if (dialogMode === 'initial') {
    <div class="col-12">
      <web-design-system-button size="small" (click)="startEdit()">Verlustbescheinigung beantragen</web-design-system-button>
    </div>
  }

  @if (dialogMode === 'edit' || dialogMode === 'verify') {
    <div class="col-12 mb-3">
      <h5>Verlustbescheinigung beantragen</h5>
    </div>
    <div class="col-12">
      <form class="row" (ngSubmit)="onSubmit(f)" #f="ngForm">
        <div class="d-flex flex-column ml-3">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="c1"
              name="chooseVVTResetType"
              required
              class="custom-control-input"
              [(ngModel)]="editData.selected"
              [value]="'both'"
            />
            <label for="c1" class="custom-control-label"
              >Verlusttopf &bdquo;Aktien&ldquo; und Verlusttopf &bdquo;Allgemein&ldquo; oder</label
            >
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="c2"
              name="chooseVVTResetType"
              required
              class="custom-control-input"
              [(ngModel)]="editData.selected"
              [value]="'stocks'"
            />
            <label for="c2" class="custom-control-label">Verlusttopf &bdquo;Aktien&ldquo; oder</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="c3"
              name="chooseVVTResetType"
              required
              class="custom-control-input"
              [(ngModel)]="editData.selected"
              [value]="'other'"
            />
            <label for="c3" class="custom-control-label">Verlusttopf &bdquo;Allgemein&ldquo;</label>
          </div>
        </div>
        <div class="col-12 mt-3 font-smaller1">
          <p>Zusätzliche Erläuterung</p>
          <ul class="font-size-smaller1">
            <li>
              Eine Verlustbescheinigung kann immer nur für den Zeitraum eines gesamten Kalenderjahres beantragt werden. In ihr werden die
              Verluste bescheinigt, die bankseitig nicht mit den während des Kalenderjahres erzielten Kapitalerträgen - auch rückwirkend -
              verrechnet werden konnten. Die Bescheinigung erfolgt getrennt nach Verlusten aus der Veräußerung von Aktien (Verlusttopf
              &bdquo;Aktien&ldquo;) und anderen Wertpapieren bzw. Geschäften (Verlusttopf &bdquo;Allgemein&ldquo;). Um eine Bescheinigung
              für das laufende Jahr zu erhalten, bitten wir, den Antrag bis spätestens 15. Dezember des laufenden Jahres online zu stellen.
              Die Beantragung einer Verlustbescheinigung empfiehlt sich u.a., wenn im laufenden Jahr Kapitalerträge bei anderen
              Kreditinstituten erzielt werden, die mit Abgeltungsteuer belastet sind. Durch die Verlustbescheinigung können diese
              Kapitalerträge im Rahmen der steuerlichen Veranlagung vom Steuerabzug ganz oder teilweise entlastet oder - soweit es sich um
              im Ausland vereinnahmten Kapitalerträge handelt - von der in der Veranlagung zu erhebenden Abgeltungsteuer befreit werden.
            </li>
            <li>Eine rückwirkende Beauftragung von Verlustbescheinigungen für vorherige Steuerjahre ist nicht möglich.</li>
            <li>
              Wird eine Verlustbescheinigung erteilt, wird der betreffende Verlusttopf mit Beginn des folgenden Jahres auf
              &bdquo;null&ldquo; gestellt. Nach Ausstellung einer Verlustbescheinigung kann der darin ausgewiesene Verlust nicht wieder in
              den Verlusttopf eingestellt werden. Er ist in der Veranlagung geltend zu machen. Dadurch wird eine doppelte Berücksichtigung
              der Verluste vermieden. Wird keine Verlustbescheinigung beantragt, wird der Verlusttopf automatisch von der Bank auf das neue
              Kalenderjahr übertragen und mit den in diesem Kalenderjahr realisierten abzugspflichtigen Kapitalerträgen im Rahmen der
              gesetzlichen Regelungen verrechnet.
            </li>
            <li>Bitte stelle nur einen Antrag, wenn tatsächlich Verluste entstanden sind.</li>
          </ul>
        </div>
        @if (dialogMode === 'edit') {
          <div class="col-12 d-flex flex-column margin-top-15 margin-bottom-15 justify-content-between">
            <span class="mb-3">Die Beantragung der Verlustbescheinigung musst Du autorisieren.</span>
            <div>
              <web-design-system-button [disabled]="!f.valid || preconditionFailed" size="small" [isSubmit]="true"
                >Weiter</web-design-system-button
              >
            </div>
          </div>
        }
      </form>
    </div>
    @if (dialogMode === 'verify') {
      <div class="col-12">
        <p class="mt-3 border-bottom d-inline-block">Bitte bestätige die Beantragung Deiner Verlustbescheinigung:</p>
        <p class="mb-1">
          Verlusttopf &bdquo;Aktien&ldquo;:
          {{ ['both', 'stocks'].indexOf(editData.selected) > -1 ? 'Ja' : 'Nein' }}
        </p>
        <p class="mb-1">
          Verlusttopf &bdquo;Allgemein&ldquo;:
          {{ ['both', 'other'].indexOf(editData.selected) > -1 ? 'Ja' : 'Nein' }}
        </p>
      </div>
      <div class="col-12 d-flex mt-3">
        <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
      </div>
    }
  }

  <div class="col-12 mt-4">
    <web-components-user-messages />
  </div>
</div>
